<div class="c-alert c-alert-danger c-alert-top c-alert-has-icon c-m-bottom-0 ea-danger-alert">
  <a class="c-a c-alert-close" aria-hidden="true">
    <i class="fa fa-times" aria-hidden="true" (click)="hideMessage()"></i>
  </a>
  <i class="fa fa-exclamation-circle c-alert-icon" aria-hidden="true"></i>
  {{ message }}
  <a class="c-link" (click)="openReviewModal()" data-qa-id="review-failed"> {{ 'bd/event-activity/form.view_failed' | translate }}</a>
</div>